export const filterOptions = (
  candidate: { data: { filter: string } },
  input: string
) => {
  if (input) {
    return candidate.data.filter?.toLowerCase()?.normalize("NFD").replace(/[^a-zA-Z\s]/g, "").includes(input?.toLowerCase().normalize("NFD").replace(/[^a-zA-Z\s]/g, ""));
  }
  return true;
};